// @ts-check
import React, { useState } from 'react';
import * as _ from 'lodash';
// utilities
import { USER_ROLES } from '../../utilities/constants';

// components
import Auth from '../Auth';
import DirectRegisterOrganizationGuideModal from './DirectRegisterOrganizationGuideModal';
import { Unpublished } from '../icons/Unpublished';
import DirectSuspendGuideModal from './DirectSuspendGuideModal';

export default function DirectRegisterOrganizationContents() {
  const [
    isShowRegisterDirectOrganizationGuideModal,
    setIsShowRegisterDirectOrganizationGuideModal,
  ] = useState(false);
  const [isShowSuspendGuideModal, setIsShowSuspendGuideModal] = useState(false);

  return (
    <React.Fragment>
      <Unpublished className='icon--2_4x ExternalServiceCooperation__contents-status-icon--updated' />
      <span className='ExternalServiceCooperation__contents-status ExternalServiceCooperation__contents-status--updated'>
        現場で利用するdirectの組織情報を登録して下さい。
      </span>
      <Auth
        approvedRoles={[
          USER_ROLES.prime,
          USER_ROLES.branch,
          USER_ROLES.manager,
        ]}
      >
        <div className='ExternalServiceCooperation__contents-btn'>
          <button
            className='btn'
            onClick={() => setIsShowRegisterDirectOrganizationGuideModal(true)}
          >
            組織情報を登録
          </button>
        </div>
      </Auth>
      <DirectRegisterOrganizationGuideModal
        visible={isShowRegisterDirectOrganizationGuideModal}
        setVisible={setIsShowRegisterDirectOrganizationGuideModal}
      />
      <Auth
        approvedRoles={[
          USER_ROLES.prime,
          USER_ROLES.branch,
          USER_ROLES.manager,
        ]}
      >
        <div className='ExternalServiceCooperation__contents-btn'>
          <button
            className='btn--negative'
            onClick={() => {
              setIsShowSuspendGuideModal(true);
            }}
          >
            連携中止
          </button>
        </div>
      </Auth>
      <DirectSuspendGuideModal
        visible={isShowSuspendGuideModal}
        setVisible={setIsShowSuspendGuideModal}
        isInUse={false}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectRegisterOrganizationContents.jsx